import { Component } from '@angular/core';
import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Observable, combineLatest, throwError } from 'rxjs';
import { catchError, map, shareReplay } from 'rxjs/operators';
import { RequestsService } from 'src/app/services/requests.service';
import { ActionsService } from 'src/app/services/actions.service';
import { HttpErrorResponse } from '@angular/common/http';
import {
  faUser,
  faUserGroup,
  faRightFromBracket,
} from '@fortawesome/free-solid-svg-icons';
import { faCircleQuestion } from '@fortawesome/free-regular-svg-icons';
import { AssistanceComponent } from '../assistance/assistance.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AuthService } from 'src/app/services/auth.service';
import { IncidentsService } from 'src/app/services/incidents.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent {
  faUser = faUser;
  faUserGroup = faUserGroup;
  faCircleQuestion = faCircleQuestion;
  faRightFromBracket = faRightFromBracket;

  language: string = 'it';
  requestCount: number = 0;
  actionsCount: number = 0;

  notFoundImg: boolean = false;

  isHandset$: Observable<boolean> = this.breakpointObserver
    .observe(Breakpoints.Handset)
    .pipe(
      map((result: any) => result.matches),
      shareReplay()
    );

  currentUser: any;
  permissions: any;

  constructor(
    private readonly breakpointObserver: BreakpointObserver,
    private readonly modalService: NgbModal,
    private readonly requestService: RequestsService,
    private readonly actionService: ActionsService,
    private readonly authService: AuthService,
    public incidentsService: IncidentsService
  ) {}

  ngOnInit(): void {
    this.currentUser = this.authService.getCurrentUserInfo();

    this.authService
      .getCurrentUser()
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
            /*             this.alertService.openSnackBar('Utente non autorizzato', 'error-snackbar', 5000, 'Chiudi') */
            this.logoutWithGoogle('Utente non autorizzato');
          });
        })
      )
      .subscribe((data: any) => {
        localStorage.setItem('permissions', JSON.stringify(data));
        this.permissions = this.authService.getCurrentPermission();
      });
    this.initData();
    combineLatest({
      pendings: this.requestService.getPendingRequestList(),
      provideds: this.requestService.getProvidedRequestList(),
    })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe(({ pendings = [], provideds = [] }) => {
        this.requestCount = pendings.length + provideds.length;
      });

    combineLatest({
      pendings: this.actionService.getPendingActionList(),
      deprovisionings: this.actionService.getDeprovisioningActionList(),
      renewals: this.actionService.getRenewalActionList(),
    })
      .pipe(
        catchError((error: HttpErrorResponse) => {
          return throwError(() => {
            console.error(error);
          });
        })
      )
      .subscribe(({ pendings = [], deprovisionings = [], renewals = [] }) => {
        this.actionsCount =
          pendings.length + deprovisionings.length + renewals.length;
      });
  }

  initData() {
    this.actionService.getAllPendingActions();
    this.actionService.getAllRenewalsActions();
    this.actionService.getAllDeprovisioningsActions();
    this.requestService.getAllPendingRequests();
    this.requestService.getAllProvidedRequests();
    this.incidentsService.getPendingIncidents();
  }

  assistanceModal() {
    const modalRef = this.modalService.open(AssistanceComponent, {
      size: 'md',
      centered: true,
    });
    modalRef.result.then(
      (result) => {
        if (result) {
          console.log(result);
        }
      },
      (error) => {
        console.log(error);
      }
    );
  }

  logoutWithGoogle(message?: string): void {
    this.authService.logoutWithGoogle(message);
  }

  getVisibility(page: any) {
    return this.authService.getVisibility(page);
  }

  notFoundImgHandler(event: Event) {
    (event.target as HTMLImageElement).style.display = 'none';
    this.notFoundImg = true;
  }
}
